// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"522":"de85179fcebdbfd8","3022":"81bbe34e255c4a51"}[chunkId] + ".js";
};